import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { ADDED_BY_ID } from "../../../Constants";
import { postLotSizeDatas } from "../../../redux/action";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { useDispatch } from "react-redux";

const statusOptions = [
    { value: 99, label: "Active" },
    { value: 100, label: "Inactive" }
]

const AddLotSize = (props) => {

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;

    const lotSizeID = props.lotSizeID;
    const singleLotSizeData = props.singleLotSizeData;
    const lotSizeDatas = props.lotSizeDatas

    let dispatch = useDispatch();

    const [lotSize, setLotSize] = useState({
        LotSizeProcedure: "",
        LS: "",
        LI: "",
        PDS: "",
        LLP: "",
        LLI: "",
        LPER: "",
        Description: "",
        StatusID: null,
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
    })

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (lotSizeID && singleLotSizeData?.length > 0) {
            const lotSizeDatas = singleLotSizeData[0];
            setLotSize({
                LotSizeProcedureID: lotSizeID,
                LotSizeProcedure: lotSizeDatas.LotSizeProcedure || "",
                LS: lotSizeDatas.LS || "",
                LI: lotSizeDatas.LI || "",
                PDS: lotSizeDatas.PDS || "",
                LLP: lotSizeDatas.LLP || "",
                LLI: lotSizeDatas.LLI || "",
                LPER: lotSizeDatas.LPER || "",
                Description: lotSizeDatas.Description || "",
                StatusID: lotSizeDatas.StatusID || "",
                CompanyID: lotSizeDatas.CompanyID || storedCompanyID,
                AddedByID: ADDED_BY_ID,
            });
        }
    }, [lotSizeID, singleLotSizeData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLotSize(prev => ({
            ...prev,
            [name]: value
        }));
        setErrors(prev => ({
            ...prev,
            [name]: "" // clear error when user starts typing
        }));
    };

    const handleSelectChange = (selectedOption) => {
        setLotSize((previousData) => ({
            ...previousData,
            StatusID: selectedOption ? selectedOption.value : null,
        }));
        setErrors((previousErrors) => ({
            ...previousErrors,
            StatusID: ""
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!lotSize.LotSizeProcedure) newErrors.LotSizeProcedure = "required!";
        if (!lotSize.LS) newErrors.LS = "required!";
        if (!lotSize.LI) newErrors.LI = "required!";
        if (!lotSize.PDS) newErrors.PDS = "required!";
        if (!lotSize.LLP) newErrors.LLP = "required!";
        if (!lotSize.LLI) newErrors.LLI = "required!";
        if (!lotSize.LPER) newErrors.LPER = "required!";
        if (!lotSize.Description) newErrors.Description = "required!";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddLotSize = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(lotSize),
            };
            dispatch(postLotSizeDatas(requestOption, props.handleCloseModal, lotSizeID, lotSizeDatas));
            console.log(lotSize, 'lotSize');
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className='add-role-modal' centered>
                <Modal.Header closeButton>
                    <Modal.Title>{lotSizeID ? "Edit Lot Size" : "Add Lot Size"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label>Lot Size Procedure</label>
                                        <Form.Control
                                            type="text"
                                            name="LotSizeProcedure"
                                            value={lotSize.LotSizeProcedure}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.LotSizeProcedure && <div className="text-danger">{errors.LotSizeProcedure}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>LS</label>
                                        <Form.Control
                                            type="text"
                                            name="LS"
                                            value={lotSize.LS}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.LS && <div className="text-danger">{errors.LS}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label>LI</label>
                                        <Form.Control
                                            type="text"
                                            name="LI"
                                            value={lotSize.LI}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.LI && <div className="text-danger">{errors.LI}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label> Pds</label>
                                        <Form.Control
                                            type="text"
                                            name="PDS"
                                            value={lotSize.PDS}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.PDS && <div className="text-danger">{errors.PDS}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label> LLP</label>
                                        <Form.Control
                                            type="text"
                                            name="LLP"
                                            value={lotSize.LLP}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.LLP && <div className="text-danger">{errors.LLP}</div>}
                                </Col>
                                <Col md={4}>
                                    <div>
                                        <label> LLI </label>
                                        <Form.Control
                                            type="text"
                                            name="LLI"
                                            value={lotSize.LLI}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.LLI && <div className="text-danger">{errors.LLI}</div>}
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div>
                                        <label> Lper</label>
                                        <Form.Control
                                            type="text"
                                            name="LPER"
                                            value={lotSize.LPER}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.LPER && <div className="text-danger">{errors.LPER}</div>}
                                </Col>
                                <Col md={8}>
                                    <div>
                                        <label className="pb-2 pt-2"> Description</label>
                                        <Form.Control
                                            type="text"
                                            name="Description"
                                            value={lotSize.Description}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {errors.Description && <div className="text-danger">{errors.Description}</div>}
                                </Col>
                            </Row>
                            <Row>
                                {lotSizeID && <Col md={6}>
                                    <div>
                                        <label>Status <span className="required-asterisk">*</span></label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={statusOptions}
                                            value={statusOptions.find(option => option.value === lotSize.StatusID) || null}
                                            onChange={(selected) => handleSelectChange(selected, "StatusID")}
                                            placeholder="Select"
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}  // Prevents auto-scrolling issues
                                        />
                                    </div>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddLotSize} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddLotSize;
